import QueryString from 'query-string';
import _ from 'lodash';
import * as BoardsService from 'common/services/boards.service';
import {
  DateSelectionChanged as _dateSelected,
  toggleSnackBar as _toggleSnackBar,
  setDefaultBoardSucceed,
  setDefaultBoardFailure,
  selectIterationId,
  selectPeriodKey,
  setIsBlurred,
  toggleModal
} from '../actions';
import store from '../store/configureStore';
import { isTeamLicenseSelector, licenseSelector } from '../selectors/license';
import moment from 'moment';
import { createDataRetentionModalOptions } from 'modals/modal-options-factory';
import { getLatestIterationSelector } from '../selectors/iterations-picker';
import { isBlurredSelector } from '../selectors/ui-state';
import { DAYS_PARAM } from 'common/constants/constants';
import { PERIODS } from 'components/PeriodPicker/periods/constants';

export function DateSelectionChanged(params = {}) {
  const {
    id: iterationId,
    end_date,
    selectedPeriodKey = PERIODS.ITERATIONS.periodKey
  } = params;
  const search = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  if (iterationId) {
    window.history.replaceState(
      null,
      null,
      `?${QueryString.stringify(
        Object.assign(
          {},
          Object.assign({}, search, { iteration_id: params.id })
        )
      )}`
    );
  } else {
    window.history.replaceState(
      null,
      null,
      `?${QueryString.stringify(
        Object.assign(
          {},
          _.omit(
            QueryString.parse(window.location.search, {
              ignoreQueryPrefix: true
            }),
            'iteration_id'
          )
        )
      )}`
    );
  }
  const state = store.getState();
  const { retentionDays } = licenseSelector(state);
  const isTeamLicense = isTeamLicenseSelector(state);

  const latestIteration = getLatestIterationSelector(state);
  const isBlurred = isBlurredSelector(state);

  const handleDataRetention = dispatch => {
    if (
      moment().isAfter(
        moment(end_date).add(retentionDays, DAYS_PARAM).startOf('day')
      )
    ) {
      const onBackToCurrentIteration = () =>
        dispatch(DateSelectionChanged(latestIteration));
      dispatch(
        toggleModal(
          createDataRetentionModalOptions({ onBackToCurrentIteration })
        )
      );
      dispatch(setIsBlurred(true));
    } else if (isBlurred) {
      dispatch(toggleModal());
      dispatch(setIsBlurred(false));
    }
  };

  return async dispatch => {
    try {
      retentionDays && !isTeamLicense && handleDataRetention(dispatch);
      dispatch(_dateSelected(params));
      dispatch(selectPeriodKey(selectedPeriodKey));
      if (iterationId) {
        dispatch(selectIterationId(iterationId));
      }
    } catch (e) {
      // Handle failure when an indication is needed
    }
  };
}

export function toggleSnackBar(params) {
  return async dispatch => {
    try {
      dispatch(_toggleSnackBar(params));
    } catch (e) {
      // Handle failure when an indication is needed
    }
  };
}

export function setDefaultBoard({ board_id, team_id }) {
  return async dispatch => {
    try {
      const newDefaultBoard = await BoardsService.setDefaultBoard(
        board_id,
        team_id
      );
      dispatch(setDefaultBoardSucceed(newDefaultBoard));
      return newDefaultBoard;
    } catch (e) {
      dispatch(setDefaultBoardFailure());
      throw e;
    }
  };
}

export function changeDefaultBoard(board) {
  return async dispatch => {
    try {
      dispatch(setDefaultBoardSucceed(board));
      return board;
    } catch (e) {
      throw e;
    }
  };
}
